<template>
  <button :type="type" :class="['btn', `btn-${variant}`, block && 'btn-block']" :disabled="disabled">
    <slot></slot>
  </button>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BButton',
  props: {
    variant: { type: String, default: 'secondary' },
    block: Boolean,
    disabled: Boolean,
    type: { type: String, default: 'button' }
  }
})
</script>
